import { Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { IwgSelect } from 'src/app/shared/models/iwgselect.model';
import { BaseService } from 'src/app/shared/services';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

const noop = () => {
};

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CountrySelectComponent),
  multi: true
};

@Component({
  selector: 'app-country-select',
  templateUrl: './country-select.component.html',
  styleUrls: ['./country-select.component.scss'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class CountrySelectComponent implements ControlValueAccessor,OnChanges {

  @Input() preselectedItemId;
  @Input() isDisabled = false;
  @Input() isRequired = false;
  @Input() activeonly = false;
  @Input() alltext = 'All';
  items:IwgSelect[] = [];
  @Input() ShowHelp = false;
  @Input() labeltext = 'Country';
  countryId: number;
  @Input() helptext = '';
  @Input() showAll = false;
  @Input() showAllCountries = false;
  @Input() idOnly = true;
  @Input() disabled:boolean = false;
  @Output() countryChange = new EventEmitter();
  @Input()  showcallingcode = false;
  @Input()  customcss = false;
  isLoading:boolean = false;
  isOpen:boolean = false;
  isselected:boolean = false;

  constructor(private baseService: BaseService) { }

  ngOnChanges(changes: SimpleChanges){
    if ('preselectedItemId' in changes) {
        if(this.preselectedItemId != null && !this.isselected){
          this.isselected = true;
          this.get(true);
        }
    }
  }
  get(setId=false){
    this.isLoading = true;
    const param = {limit: 0, showAll: this.showAll, showAllCountries: this.showAllCountries, showcallingcode: this.showcallingcode };
    this.baseService.getEntityData('COUNTRY', param).pipe(catchError((err) => {
    throw (err);
    }))
    .subscribe(result => {
      this.isLoading = false;
      if (result.apiCallStatus && result.data) {
          this.items = result.data.Data;
          if(this.preselectedItemId && setId && this.items){
            if(this.idOnly){
              this.value = this.items.find(item=>item.Abbreviation == this.preselectedItemId)
            }else{
              this.value = this.items.find(item=>item.ID == this.preselectedItemId)
            }
            if(this.preselectedItemId == -1){
              this.value = -1;
            }
          }
      }
    },
    error => {
        this.isLoading = false;
        console.log(error);
    });
  }

  private innerValue: any = '';
  get value(): any {return this.innerValue;};
  set value(v: any) {
      if (v !== this.innerValue) {
        this.innerValue = v;this.onChangeCallback(v);
      }
  }
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;
  writeValue(value: any) {if (value !== this.innerValue) { this.innerValue = value;}}
  registerOnChange(fn: any) {this.onChangeCallback = fn;}
  registerOnTouched(fn: any) {this.onTouchedCallback = fn;}

  onOpen(event){
    this.isOpen = event;
    if(!event || this.items.length>0){
      return;
    } 
    this.isLoading = true;
       this.get();

  }
  objectComparison = function( option, value ) : boolean {
    if (!option || !value) {
      return false;
    }
    return (option.Abbreviation == value || option.ID == value || option.ID === value.ID);
  }

  onCountryChange($event): void {
    this.countryChange.emit($event.value);
  }

}
